import { useEffect, useMemo } from 'react';

export const useActual = (): Function => {
  const state = useMemo(() => ({ id: 0 }), []);

  // Nothing is "actual" after unmount — invalidate every outstanding callback,
  // so late .then chains stop calling setState on the unmounted component.
  useEffect(() => () => {
    state.id += 1;
  }, [state]);

  return useMemo(() => {
    return (): Function => {
      state.id += 1;
      const currId = state.id;
      return (): boolean => currId === state.id;
    };
  }, [state]);
};
